<template>
  <li>
    <SmartLink
      class="menu-button"
      :url="item.url"
      :target="item.target"
      :route="item.route"
      :method="item.method"
      :event="item.event"
      :event-data="item"
      v-on="$listeners"
    >
      <component v-if="getItemType !== 'checkbox'" :is="item.icon" />
      <template v-else>
        <span v-if="checkboxStyle === 'inline'" :class="clsx('menu-button--checkbox', { 'menu-button--checked': isChecked })">
          <CheckIcon v-if="isChecked" />
        </span>
        <span v-else :class="clsx('menu-button--checkbox-styled', { 'menu-button--checkbox-styled--checked': isChecked })"></span>
      </template>
      {{ item.name }}
      <OpenDownIcon v-if="item.subitems" class="menu-button--subitems ml-2" />
      <div class="nested-menu-list-wrapper">
        <slot></slot>
      </div>
    </SmartLink>
  </li>
</template>

<script>
import { clsx } from 'clsx';
import { CheckIcon, OpenDownIcon } from '@/shared/ui/icons';
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    item: {
      type: Object,
      default: null,
      required: true,
    },
    selectedItem: {
      type: Object,
      default: () => {},
      required: false,
    },
    checkboxStyle: {
      type: String,
      default: 'inline',
      validator: (value) => ['inline', 'styled'].includes(value),
    },
  },
  components: { OpenDownIcon, CheckIcon, SmartLink },
  computed: {
    getItemType() {
      return this.item.options?.type || 'simple';
    },
    isChecked() {
      if (Array.isArray(this.selectedItem?.id)) {
        return this.item?.id !== undefined && this.selectedItem?.id?.includes(this.item?.id);
      }

      return this.selectedItem?.id === this.item?.id;
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.menu-button {
  position: relative;
  display: flex;
  align-items: center;
  color: #09090B;
  white-space: nowrap;
  padding: 8px;
  text-align: left;

  &:hover {
    background-color: #D4D4D8;
    border-radius: 6px;

    > .nested-menu-list-wrapper {
      display: block;
    }
  }

  &--subitems {
    transform: rotate(-90deg);
  }

  &--checkbox {
    display: inline-block;
    padding-right: 3px;
    width: 20px;
  }

  &--checkbox-styled {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    min-width: 20px;
    border: 1px solid #D5D7DA;
    border-radius: 6px;
    background: white;
    transition: all 0.2s ease;
    margin-right: 8px;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      left: 6px;
      top: 3px;
      width: 5px;
      height: 10px;
      border: solid #FB923C;
      border-width: 0 2px 2px 0;
      opacity: 0;
      transform: rotate(45deg) scale(0);
      transition: all 0.2s ease;
    }

    &--checked {
      border-color: #FB923C;

      &::after {
        opacity: 1;
        transform: rotate(45deg) scale(1);
      }
    }
  }
}

.nested-menu-list {
  &-wrapper {
    display: none;
    position: absolute;
    top: 0;
    left: 100%;
    padding-left: 15px;

    & > .menu-list {
      border: 1px solid #E5E5E7;
      border-radius: 6px;
      padding: 12px 8px;
      box-shadow: 0px 2px 4px -1px #0000000F, 0px 4px 6px -1px #0000001A;
    }
  }
}
</style>
